import { useLocation } from 'react-router-dom';

export const useFrom = () => {
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  return from;
};
